
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectFilterLight/ProjectFilterLight.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectFilterLight.html');
        
        var script = require('./ProjectFilterLight.ts').default;
        module.exports = require('./ProjectFilterLight.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    